import type { SessionUser } from '#src/shared/session';

type Result = ModelHookResult<{
	isComplete: boolean;
}>;

export function useCurrentUserAddressIsComplete(currentUser: SessionUser | undefined): Result {
	return {
		data: {
			isComplete: Boolean(
				currentUser &&
				currentUser.address &&
				currentUser.city &&
				currentUser.country?.countryCode &&
				currentUser.state?.stateCode &&
				currentUser.postalCode,
			),
		},
	};
}
